import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../../common/Auth';
import { filterProductAllowedColors } from '../../wrappers/product/util/filterProductColors';
import ProductModalContent from './ProductModalContent';

function ProductModal({ product, fullProduct, show, onHide }) {
  const [productLayoutMain, setProductLayoutMain] = useState('');
  const [productLayout, setProductLayout] = useState('');
  const { themeSettingsData, userGroupsData } = useContext(AuthContext);

  useEffect(() => {
    if (themeSettingsData?.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === 'theme' && i.values[0].productLayout !== '') {
          setProductLayoutMain(i.values[0].productLayout);
        }
      });
    }
  }, [themeSettingsData]);

  useEffect(() => {
    if (!!fullProduct?.productLayout) {
      setProductLayout(fullProduct.productLayout);
    } else {
      setProductLayout(productLayoutMain);
    }
  }, [fullProduct, productLayoutMain]);

  const filteredProduct = useMemo(
    () => filterProductAllowedColors(fullProduct, userGroupsData ?? []),
    [fullProduct, userGroupsData],
  );

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="lg"
      className={`product-quickview-modal-wrapper${
        productLayout === 'product-condensed' ? ' productCondensedModal' : ''
      }`}
    >
      <DialogTitle display="flex" justifyContent="flex-end">
        <IconButton onClick={onHide} sx={{ padding: 0 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <ProductModalContent product={filteredProduct} />
      </DialogContent>
    </Dialog>
  );
}

ProductModal.propTypes = {
  onHide: PropTypes.func,
  product: PropTypes.object,
  show: PropTypes.bool,
  fullProduct: PropTypes.object,
};

export default ProductModal;
